import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import "./fonts/Architects_Daughter/ArchitectsDaughter-Regular.ttf";
import "./fonts/Lato/Lato-Regular.ttf";
import "./fonts/Raleway/Raleway-VariableFont_wght.ttf";
import "./fonts/Roboto/Roboto-Medium.ttf";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);


